module.exports = __webpack_public_path__ + "img/monuments.ff933d9a.png";